import { IProductPriceRange } from '@/interfaces';
import { orderBy } from 'lodash';

export const PRODUCT_PHOTO_COLOR = {
  BUNDLE: '#00AEC7',
  KIT: '#C820FF',
  PROBIOTIC: '#2B36BA',
  // COACH_PROGRAM: '#FFAC00',
  FMT: '#FFAC00',
};

export const PRODUCT_PHOTO_ICON = {
  BUNDLE: 'box',
  KIT: 'laboratory',
  PROBIOTIC: 'supplement',
  // COACH_PROGRAM: 'starFilled',
  FMT: 'extraction',
};

export const checkOverlap = (priceRangeInput: IProductPriceRange[]) => {
  const sorted = orderBy([...priceRangeInput], ['quantityFrom'], ['asc']);

  for (let i = 0; i < sorted.length - 1; i++) {
    const current = sorted[i];
    const next = sorted[i + 1];

    // Check degenerate range and overlap
    if (next?.quantityFrom !== (current?.quantityTo ?? 0) + 1) return true;
  }

  return false;
};
